let info = {
  name: "Matias Scheinkman",
  logo_name: "Matias Scheinkman",
  flat_picture: require("./src/assets/fotologo.jpeg"),
  config: {
    use_cookies: false,
    navbar: {
      blur: false
    }
  },
  description:
    "A home-awarded frontend developer from Corrientes 🧉 (Argentina) currently living in the sunny Barcelona 🌞.\
    <br>I've worked with music and different people for many years and that's why now, I choose websites..\
    <br>I collaborate with the marketing team of the current company I work for to develop, maintain and anhance a variety of websites in an industrial market and some \
    e-commerces for a wide customer profile while we give them the best web experience.\
    <br>Created (and screwed) many start-up companies, lived in more than 6 different cities, speak 5 different languages, played music for many bands, \
    learned how to code after my 30's, travelled by car, bus, at the sit of my lovely bike, backpacked, camped, cooked, hicked and runned.... \
    I guess I like to stay active.\
    <br>I have 2 years of experience as a developer and I love playing/working with Javascript and some of its top frameworks to make HTML and CSS alive! 🧟‍♂️",
  links: {
    linkedin: "https://www.linkedin.com/in/matias-scheinkman",
    github: "https://github.com/scheinkman123",
    resume: "https://scheinkman123.github.io/portfolio/src/assets/pdfs/cv2023feb.pdf",
  },
  education: [
    {
      name: "Web development",
      place: "CEPI BASE SL",
      date: "sep, 2020 - dec, 2021",
      degree: "Web Aplications Developer",
      description:
        "",
      skills: [
        "Front-end developing",
        "Back-end developing",
        "Web programming",
        "DDBB management",
      ]
    },
  ],
  experience: [
    {
      name: "Web Developer",
      place: "Benmayor",
      date: "feb 2022 - present",
      position: "Web Developer - Marketing Team",
      description:
      "",
      skills: ["Javascript", "PHP", "HTML", "CSS", "Wordpress", "Elementor", "Prestashop", "SQL", "Git", "Github", "Hubspot", "Xampp"]
    },
    {
      name: "Web developer",
      place: "CEPI BASE SL",
      date: "may 2021 - dec 2021",
      position: "Intern Web Developer",
      description:
        "",
      skills: ["HTML5", "CSS3", "Bootstrap", "Javascript ES6", "Animate.css", "NodeJs", "webpack", "npm", "VueJs", "Git", "Github", "FTP"]
    },
  ],
  skills: [
    {
      title: "Languages",
      info: [
        "Javascript", "PHP", "SQL"],
      icon: "fa fa-code"
    },
    {
      title: "Frontend",
      info: [
        "HTML", "CSS", "Bootstrap", ],
      icon: "fa fa-cubes"
    },
    {
      title: "Web Technologies",
      info: ["VueJS", "ReactJS", "Wordpress", "Prestashop"],
      icon: "fas fa-laptop-code"
    },
  ],
  portfolio_design: [
    {
      name: "Keep it Green",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/Keep it green/cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/Keep it green/show.png"),
          title: "show"
        },
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Jan, 2022",
      visit: "",
      description:
        ""
    },
    {
      name: "Credit card design",
      title: "Illustration",
      pictures: [
        {
          img: require("./src/assets/designs/credit/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/credit/degisning.png"),
          title: "Degisning"
        },
        {
          img: require("./src/assets/designs/credit/Dual tune.png"),
          title: "Dual tune"
        },
        {
          img: require("./src/assets/designs/credit/Glassmorphism.png"),
          title: "Glassmorphism"
        },
        {
          img: require("./src/assets/designs/credit/Gradiant.png"),
          title: "Gradiant"
        },
        {
          img: require("./src/assets/designs/credit/Monochrome.png"),
          title: "Monochrome"
        },
        {
          img: require("./src/assets/designs/credit/Neumorphism.png"),
          title: "Neumorphism"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "BOOKSI",
      title: "E-Book library - UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/booksi/behance cover.png"),
          title: "Cover"
        },
        {
          img: require("./src/assets/designs/booksi/behance board.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/booksi/login.png"),
          title: "login"
        },
        {
          img: require("./src/assets/designs/booksi/register.png"),
          title: "register"
        },
        {
          img: require("./src/assets/designs/booksi/home page.png"),
          title: "homepage"
        },
        {
          img: require("./src/assets/designs/booksi/For you.png"),
          title: "just for you"
        }
      ],
      technologies: ["Figma"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        " BOOKSI is Ebook android app for easy read books."
    },
    {
      name: "Pill Reminder",
      title: "Pill Reminder - Mockup Design",
      pictures: [
        {
          img: require("./src/assets/designs/pill reminder/Web 1.png"),
          title: "Moodboard"
        },
        {
          img: require("./src/assets/designs/pill reminder/1.png"),
          title: "Mockups 1"
        },
        {
          img: require("./src/assets/designs/pill reminder/2.png"),
          title: "Mockups 2"
        }
      ],
      technologies: ["XD"],
      category: "Visual Design",
      github: "",
      date: "Apr, 2021",
      visit: "",
      description:
        "pill reminder app for nessecary drugs for the day."
    },
  ],
  portfolio: [
    {
      name: "Benmayor",
      pictures: [
        {
          img: require("./src/assets/portfolio/benmayor/benmayor.png")
        },
      ],
      technologies: ["Wordpress", "Elementor", "PHP", "SQL", "Javascript", "HTML", "CSS"],
      category: "",
      date: "",
      github: "https://www.benmayor.com",
      visit: "#",
      description:
        "Corporate website of industrial business group"
    },
    {
      name: "Jewelry Benmayor",
      pictures: [
        {
          img: require("./src/assets/portfolio/benmayor/jewelry.png")
        },
      ],
      technologies: ["Prestashop", "PHP", "SQL", "Javascript", "HTML", "CSS", "3rd-Party Modules"],
      category: "",
      date: "",
      github: "https://jewelry.benmayor.com",
      visit: "#",
      description:
        "Prestashop based eCommerce. Dedicated to jewelry industry, sell and provide technical service to both distributors and end customers. "
    },
    {
      name: "Flint Floor",
      pictures: [
        {
          img: require("./src/assets/portfolio/benmayor/flint.png")
        },
      ],
      technologies: ["Prestashop", "PHP", "SQL", "Javascript", "HTML", "CSS", "3rd-Party Modules"],
      category: "",
      date: "",
      github: "https://www.flintfloor.com",
      visit: "#",
      description:
        "Manufacturer of laminates for floors, walls, ceilings resistant to water and shocks for restaurants, hospitality  and housing."
    },
    {
      name: "Aismalibar",
      pictures: [
        {
          img: require("./src/assets/portfolio/benmayor/aismalibar.png")
        },
      ],
      technologies: ["Wordpress", "PHP", "SQL", "Javascript", "HTML", "CSS", "3rd-Party Modules"],
      category: "",
      date: "",
      github: "https://www.aismalibar.com",
      visit: "#",
      description:
        "Aismalibar has been manufacturing high-end Metal Clad Laminates for the printed circuit board industry for more than 60 years. Over the last two decades, AISMALIBAR has focused on providing the best solutions to reduce the operating temperature of printed circuit boards (PCBs). "
    },
    {
      name: "Dental Benmayor",
      pictures: [
        {
          img: require("./src/assets/portfolio/benmayor/dental.png")
        },
      ],
      technologies: ["Prestashop", "PHP", "SQL", "Javascript", "HTML", "CSS", "3rd-Party Modules"],
      category: "",
      date: "",
      github: "https://dental.benmayor.com",
      visit: "#",
      description:
        "Prestashop based eCommerce. Dedicated to Dental industry, sell and provide technical service for distribuitors."
    },
    {
      name: "Techno System",
      pictures: [
        {
          img: require("./src/assets/portfolio/benmayor/technosystem.png")
        },
      ],
      technologies: ["Prestashop", "PHP", "SQL", "Javascript", "HTML", "CSS", "3rd-Party Modules"],
      category: "",
      date: "",
      github: "https://www.techno-system.es",
      visit: "#",
      description:
        "Industrial automation: The most advanced form of integration, with robotic arms and seamlessly connected to peripheral systems through robotization."
    },
    {
      name: "Kicker",
      pictures: [
        {
          img: require("./src/assets/portfolio/kicker/kicker1.png")
        },
        {
          img: require("./src/assets/portfolio/kicker/kicker2.png")
        },
      ],
      technologies: ["HTML5", "CSS3", "Bootstrap"],
      category: "Web App",
      date: "Mar, 2021 - May, 2021",
      github: "https://scheinkman123.github.io/Kicker/",
      visit: "#",
      description:
        "Web blog for new-parents. Basic web layout based on HTML and CSS with flexbox and mobile-first approach"
    },
    {
      name: "Mongoose DB App",
      pictures: [
        {
          img: require("./src/assets/portfolio/mongoose/mongo1.png")
        },
        {
          img: require("./src/assets/portfolio/mongoose/mongo2.png")
        },
      ],
      technologies: ["HTML", "CSS", "JavaSript"],
      category: "Web App",
      date: "Apr, 2021 - May, 2021",
      github: "https://scheinkman123.github.io/Mongoose/",
      visit: "#",
      description:
        "Immitation of the Javascript library for data modeling."
    },
    {
      name: "Fotobook",
      pictures: [
        {
          img: require("./src/assets/portfolio/fotobook/fotobook1.png")
        },
      ],
      technologies: ["Javascript", "Animate.CSS", "Google Maps API"],
      category: "Web App",
      date: "Apr, 2021 - May, 2021",
      github: "https://scheinkman123.github.io/fotobook/",
      visit: "#",
      description:
        "Photographers and designers catalog website based on HTML with multiple Javascript features (i.e login popup)"
    },
    {
      name: "1st portfolio",
      pictures: [
        {
          img: require("./src/assets/portfolio/portfolio-html/portf1.png")
        },
      ],
      technologies: ["HTML", "CSS", "Bootstrap", "Git", "Github"],
      category: "Web App",
      date: "May, 2021 - Jun, 2021",
      github: "https://scheinkman123.github.io/portfolio-html/",
      visit: "#",
      description:
        "Previous version of a personal portfolio website based on HTML with free layout design"
    },
  ],
};

export default info;